export default __webpack_public_path__ + "static/media/slim.936c6e5a.svg";